<template>
  <div class="container mt-4 mb-5">
    <div class="row">
      <div class="col-12 bread-crump-area">
        <ol>
          <li>
            <router-link :to="'/' + this.$store.state.langCodeX">
              {{ this.$store.getters.getWordLocale("txt_anasayfa") }} ▸
            </router-link>
          </li>
          <li>
            <span>{{
              this.$store.getters.getWordLocale("txt_talep_listesi")
            }}</span>
          </li>
        </ol>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12">
        <a
          v-on:click="toggleFilters"
          class="
            d-xl-none d-lg-none d-md-inline-flex d-inline-flex
            btn
            filtre-btn
          "
          ><i class="material-icons-outlined">filter_alt</i> Advanced Filter</a
        >
        <div class="lead-list-page">
          <ForieLoader
            class="c-loader"
            v-show="showLoader && this.$store.state.domainSystemX == 1"
          />
          <TeLoader
            class="c-loader"
            v-show="showLoader && this.$store.state.domainSystemX == 2"
          />

          <div
            class="text-center alert alert-warning"
            v-show="leadListData.length == 0 && showLoader == false"
          >
            <i class="fa fa-info-circle"></i>
            {{
              this.$store.getters.getWordLocale(
                "txt_aradiginiz_talep_bulunamadi"
              )
            }}
          </div>

          <div
            class="lead-item"
            v-for="(lead, lIndex) in leadListData"
            :key="lIndex"
          >
            <div class="col-12 lead-page-lead-item">
              <div class="lead-item-top">
                <router-link
                  :to="'/' + this.$store.state.langCodeX + '/lead/' + lead.link"
                >
                  <country-flag :country="lead.countryCode" size="normal" />

                  <WordHighlighter :query="this.$store.state.searchInputValueX">
                    {{ lead.title }}
                  </WordHighlighter>
                </router-link>

                <WordHighlighter :query="this.$store.state.searchInputValueX">
                  {{ lead.summary }}
                </WordHighlighter>

                <ul>
                  <li>
                    <span class="material-icons-outlined"> card_travel </span>
                    <abbr>
                      {{
                        lead.leadType == 0
                          ? this.$store.getters.getWordLocale("txt_alim_talebi")
                          : lead.leadType == 1
                          ? this.$store.getters.getWordLocale(
                              "txt_satis_teklifi"
                            )
                          : this.$store.getters.getWordLocale("txt_isbirligi")
                      }}
                    </abbr>
                  </li>
                  <li v-if="lead.credit > 0">
                    <span class="material-icons-outlined"> copyright </span>
                    <abbr
                      >{{ lead.credit }}
                      {{ this.$store.getters.getWordLocale("txt_kredi") }}</abbr
                    >
                  </li>
                  <li v-else>
                    <span class="material-icons-outlined"> handshake </span>
                    <abbr>{{
                      this.$store.getters.getWordLocale("txt_ucretsiz")
                    }}</abbr>
                  </li>
                 
                  <li>
                    <span class="material-icons-outlined"> schedule </span>
                    <abbr>{{ lead.createTime }}</abbr>
                  </li>
                  <li>
                    <span class="material-icons-outlined"> flag </span>
                    <abbr>{{ lead.countryName }}</abbr>
                  </li>
                </ul>
              </div>
              <div class="lead-item-bottom">
                <ul>
                  <li  v-for="(keyword, lkIndex) in lead.keywords"
                      :key="lkIndex"
                      v-show="lkIndex < 5">
                    <a href="javascript:;">{{keyword}}</a>
                  </li>              
                </ul>
              </div>
            </div>
          </div>

          <div style="height: 70px" v-show="currentPage > 0 && showMoreLoader">
            <ForieLoader
              class="more-svg"
              v-show="this.$store.state.domainSystemX == 1"
            />
            <TeLoader
              class="more-svg"
              v-show="this.$store.state.domainSystemX == 2"
            />
          </div>

          <div v-show="noMoreLeads == false && leadListData.length > 0">
            <div class="d-flex justify-content-center more-company-box mb-4">
              <a
                v-on:click="getLeadsList(currentPage + 1)"
                href="javascript:;"
                class="btn btn-large-primary-button mt-2"
                >{{
                  this.$store.getters.getWordLocale("txt_daha_fazla_yukle")
                }}</a
              >
            </div>
          </div>
        </div>
      </div>

      <div
        v-bind:class="{
          'col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12': true,
          'filters-box-control': true,
          show: showFilters,
        }"
      >
        <div v-show="hasFilterItems" class="filters-box">
          <div
            class="d-flex justify-content-between align-items-center mt-3 mb-4"
          >
            <span>{{
              this.$store.getters.getWordLocale("txt_filterleme")
            }}</span>
            <a
              v-on:click="toggleFilters"
              class="
                mobile-filtre-close
                d-xl-none d-lg-none d-md-inline-flex d-inline-flex
              "
              href="javascript:;"
            >
              x
            </a>
          </div>
          <div
            v-if="hasLeadTypes"
            class="d-flex flex-wrap filters-leads-status"
          >
            <div class="d-flex flex-wrap leads-filter-area">
              <div class="form-check p-0 me-1">
                <input
                  type="radio"
                  class="btn-check"
                  name="options-outlined"
                  id="all"
                  :checked="selectedLeadType == -1"
                  autocomplete="off"
                  @click="setSelectedLeadType(-1)"
                />
                <label
                  class="btn btn-outline-on-secondary w-100 mb-2"
                  for="all"
                  >{{ this.$store.getters.getWordLocale("txt_tumu") }}</label
                >
              </div>
              <div
                v-for="(type, index) in leadTypes"
                :key="index"
                class="form-check p-0 me-1"
                v-show="
                  selectedLeadTypes.indexOf(type.id) !== -1 ||
                  selectedLeadTypes.length == 0
                "
              >
                <input
                  type="radio"
                  class="btn-check"
                  name="options-outlined"
                  :id="'request-' + type.id"
                  @click="setSelectedLeadType(type.id)"
                  autocomplete="off"
                />
                <label
                  class="btn btn-outline-on-secondary"
                  :for="'request-' + type.id"
                >
                  {{ type.label }}</label
                >
              </div>
            </div>
          </div>

          <div v-if="hasKeywords" class="did-floating-label-content">
            <input
              class="did-floating-input form-control"
              type="text"
              v-model="searchText"
             :placeholder="this.$store.getters.getWordLocale('txt_ara')"
            />
            <label class="did-floating-label">{{
              this.$store.getters.getWordLocale("txt_ara")
            }}</label>
          </div>

          <div v-show="hasCategory" class="did-floating-label-content">
            <select
              @change="setSelectedMainCategory($event.target.value)"
              class="did-floating-select form-control"
              v-model="selectedMainCategory"
            >
              <option value="0" selected>All</option>
              <option
                v-for="(cat, pIndex) in mainCategories"
                :key="pIndex"
                :value="cat.id"
              >
                {{ cat.text }}
              </option>
            </select>
            <label class="did-floating-label">{{
              this.$store.getters.getWordLocale("txt_kategori")
            }}</label>
          </div>
          <div
            v-show="selectedMainCategory > 0"
            class="did-floating-label-content did-error-input"
          >
            <select
              @change="setSelectedSubCategory($event.target.value)"
              class="did-floating-select form-control"
              v-model="selectedSubCategory"
            >
              <option value="0" selected>
                {{ this.$store.getters.getWordLocale("txt_tumu") }}
              </option>
              <option
                v-for="(cat, pIndex) in subCategories"
                :key="pIndex"
                :value="cat.id"
              >
                {{ cat.text }}
              </option>
            </select>
            <label class="did-floating-label">{{
              this.$store.getters.getWordLocale("txt_alt_katrgori")
            }}</label>
          </div>

          <div
            v-show="hasCountry"
            class="did-floating-label-content did-error-input"
          >
            <select
              @change="setSelectedCountry($event.target.value)"
              class="did-floating-select form-control"
              v-model="selectedCountry"
            >
              <option value="0" selected>
                {{ this.$store.getters.getWordLocale("txt_tumu") }}
              </option>
              <option
                v-for="(country, pIndex) in countries"
                :key="pIndex"
                :value="country.id"
              >
                {{ country.text }}
              </option>
            </select>
            <label class="did-floating-label">{{
              this.$store.getters.getWordLocale("txt_ulke")
            }}</label>
          </div>

          <div class="d-flex justify-content-between">
            <a
              v-on:click="clearFilters"
              class="btn btn-reset-filters"
              href="javascript:;"
              >{{ this.$store.getters.getWordLocale("txt_sifirla") }}</a
            >
            <a
              v-on:click="getLeadsList(0)"
              class="btn apply-btn"
              href="javascript:;"
              >{{ this.$store.getters.getWordLocale("txt_uygula") }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import CountryFlag from "vue-country-flag-next";
import moment from "moment";
import helper from "./helper.js";
import ForieLoader from "../shared/ForieLoader.vue";
import TeLoader from "../shared/TeLoader.vue";
import { mapState } from "vuex";
import WordHighlighter from "vue-word-highlighter";

export default {
  computed: mapState({
    isSearchChangedX: (state) => state.isSearchChangedX,
  }),
  watch: {
    isSearchChangedX(newVal) {
      if (newVal == true) {
        this.searchText = this.$store.state.searchInputValueX;
        this.getLeadsList(0);
      }
    },
  },
  components: {
    ForieLoader,
    TeLoader,
    CountryFlag,
    WordHighlighter,
  },
  data() {
    return {
      showFilters: false,
      showLoader: true,
      showMoreLoader: true,
      selectedLeadTypes: [],
      countriesFullData: [],
      mainCategoriesFullData: [],
      subCategoriesFullData: [],
      leadTypes: [
        { id: 0, label: this.$store.getters.getWordLocale("txt_alim_talebi") },
        {
          id: 1,
          label: this.$store.getters.getWordLocale("txt_satis_teklifi"),
        },
        { id: 2, label: this.$store.getters.getWordLocale("txt_isbirligi") },
      ],
      selectedMainAndSubCategories: [],
      leadListData: [],
      noMoreLeads: false,
      selectedCountries: [],
      selectedLeads: [],
      selectedCategories: [],
      keywords: [],
      currentPage: 0,
      skipValueLeads: 0,
      searchText: "",
      hasFilterItems: false,
      selectedMainCategory: 0,
      selectedSubCategory: 0,
      selectedCountry: 0,
      mainCategories: [],
      subCategories: [],
      countries: [],
      hasCategory: false,
      hasKeywords: false,
      hasCountry: false,
      hasLeadTypes: false,
      selectedLeadType: -1,
    };
  },
  methods: {
    async getMainCategories() {
      var temp = [];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getMainCategories`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (temp = data))
        .catch((err) => console.log(err.message));

      this.mainCategoriesFullData = temp;

      temp.forEach((element) => {
        var mainCategoryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name;
        if (this.selectedMainAndSubCategories.length > 0) {
          if (
            this.selectedMainAndSubCategories.filter(
              (q) => q.mainCategoryId == mainCategoryId
            ).length > 0
          ) {
            this.mainCategories.push({
              text: name,
              id: mainCategoryId,
            });
          }
        } else {
          this.mainCategories.push({
            text: name,
            id: mainCategoryId,
          });
        }
      });
    },
    setSelectedMainCategory(id) {
      this.selectedMainCategory = parseInt(id);
      this.subCategories = [];
      this.getSubCategories();
    },
    async getSubCategories() {
      if (this.selectedMainCategory == 0) {
        this.subCategories = [];
        return;
      }
      var mainIdList = [];
      mainIdList.push(this.selectedMainCategory);
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getSubCategories`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            categoryIdList: mainIdList,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.subCategories = data))
        .catch((err) => console.log(err.message));

      this.subCategoriesFullData = this.subCategories;
      var tempList = [];
      this.subCategories.forEach((element) => {
        var subCategoryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name;

        if (this.selectedMainAndSubCategories.length > 0) {
          if (
            this.selectedMainAndSubCategories.filter(
              (q) => q.categoryId == subCategoryId
            ).length > 0
          ) {
            tempList.push({
              text: name,
              id: subCategoryId,
            });
          }
        } else {
          tempList.push({
            text: name,
            id: subCategoryId,
          });
        }
      });
      this.subCategories = [];
      this.subCategories = tempList;
    },
    setSelectedSubCategory(id) {
      this.selectedSubCategory = parseInt(id);
    },
    setSelectedLeadType(id) {
      this.selectedLeadType = parseInt(id);
    },
    async getCountries() {
      var tempList = [];

      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCountries`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (tempList = data))
        .catch((err) => console.log(err.message));

      this.countriesFullData = tempList;

      tempList.forEach((element) => {
        var countryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name
            : element.TagName;

        if (this.selectedCountries.length > 0) {
          if (this.selectedCountries.indexOf(countryId) !== -1) {
            this.countries.push({
              text: name,
              id: parseInt(element._id),
              flag: element.Flag,
            });
          }
        } else {
          this.countries.push({
            text: name,
            id: parseInt(element._id),
            flag: element.Flag,
          });
        }
      });
    },
    setSelectedCountry(id) {
      this.selectedCountry = parseInt(id);
    },
    async getLeadsList(page) {
      if (page > 0) {
        this.showMoreLoader = true;
      } else {
        this.showLoader = true;
      }

      this.currentPage = page;
      if (this.currentPage == 0) {
        this.leadListData = [];
        this.skipValueLeads = 0;
      } else {
        this.skipValueLeads = this.currentPage * 20;
      }
      if (this.searchText != "") {
        this.$store.state.searchInputValueX = this.searchText;
      } else {
        this.$store.state.searchInputValueX = "";
      }
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getLeadsListForDomainsTest`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            domainSystem: this.$store.state.domainSystemX,
            selectedLeadType:
              this.selectedLeadType == -1 ? null : this.selectedLeadType,
            keywords: this.keywords.length == 0 ? null : this.keywords,
            selectedCategories:
              this.selectedSubCategory > 0
                ? [this.selectedSubCategory]
                : this.selectedCategories.length == 0
                ? null
                : this.selectedCategories,
            selectedMainCategories:
              this.selectedMainCategory > 0
                ? [this.selectedMainCategory]
                : null,
            selectedLeads:
              this.selectedLeads.length == 0 ? null : this.selectedLeads,
            selectedCountries:
              this.selectedCountry > 0
                ? [this.selectedCountry]
                : this.selectedCountries.length == 0
                ? null
                : this.selectedCountries,
            search: this.$store.state.searchInputValueX,
            page: this.skipValueLeads,
            selectedLeadTypes: this.selectedLeadTypes,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.leadsList = data))
        .catch((err) => console.log(err.message));

      if (this.leadsList.length < 20) {
        this.noMoreLeads = true;
      } else {
        this.noMoreLeads = false;
      }

      this.leadsList.forEach((element) => {
        var leadTitle =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Title
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Title;

        const dateObject = new Date(element.PublishTime);
        var createTime = dateObject.toLocaleString("tr-TR");

        var endDate = moment(new Date()).format("DD.MM.YYYY HH:mm:ss");
        endDate = moment(endDate, "DD.MM.YYYY HH:mm:ss");
        createTime = moment(createTime, "DD.MM.YYYY HH:mm:ss");

        var diff = endDate.diff(createTime, "days");
        if (diff == 0) {
          createTime = moment(createTime, "DD.MM.YYYY HH:mm:ss").fromNow();
        } else {
          createTime = dateObject.toLocaleString("tr-TR");
        }

        var leadId = parseInt(element._id);
        var leadType = parseInt(element.Type);
        var credit = parseInt(element.Credit);
        var countryName =
          element.Country.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length == 0
            ? element.Country.filter((q) => q.LangCode == "en").length == 0
              ? element.Country.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name
              : element.Country.filter((q) => q.LangCode == "en")[0].Name
            : element.Country.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name;
        var countryCode =
          element.Country[0] != null && element.Country[0] != undefined
            ? element.Country[0].Icon
            : "";

        var leadSummary =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].ShortDescription
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].ShortDescription;
        leadSummary =
          leadSummary == null
            ? ""
            : leadSummary.length > 150
            ? `${leadSummary.substr(0, 150)}...`
            : leadSummary;

        var leadKeywords =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Keywords
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Keywords;
        leadKeywords = leadKeywords.split(",");
        var link = element.LinkString;
        this.leadListData.push({
          id: leadId,
          title: leadTitle,
          link: link,
          createTime: createTime,
          countryName: countryName,
          countryCode: countryCode !== null ? countryCode.toLowerCase() : "",
          summary: leadSummary,
          keywords: leadKeywords,
          leadType: leadType,
          credit: credit,
        });
      });
      this.$store.state.isSearchChangedX = false;
      this.showLoader = false;
      this.showMoreLoader = false;
    },
    clearFilters() {
      this.selectedMainCategory = 0;
      this.selectedSubCategory = 0;
      this.searchText = "";
      this.selectedCountry = 0;
      this.selectedLeadType = -1;
      this.$store.state.searchInputValueX = "";

      this.getLeadsList(0);
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
  },
  mounted() {
    moment.locale(`${this.$store.state.langCodeX}`);

    if (this.$store.state.searchInputValueX != "") {
      this.searchText = this.$store.state.searchInputValueX;
    }
    // #region Left Side Filter
    this.hasFilterItems =
      this.$store.state.domainContentX.FilterContent.filter(
        (q) => q.id == "2" && parseInt(q.status) == 1
      ).length > 0
        ? true
        : false;

    if (this.hasFilterItems == true) {
      var filterItems = this.$store.state.domainContentX.FilterContent.filter(
        (q) => q.id == "2" && parseInt(q.status) == 1
      )[0].items;

      this.hasCategory =
        filterItems.filter((q) => parseInt(q.id) == 1 && q.status == 1).length >
        0;

      this.hasKeywords =
        filterItems.filter((q) => parseInt(q.id) == 3 && q.status == 1).length >
        0;
      this.hasCountry =
        filterItems.filter((q) => parseInt(q.id) == 4 && q.status == 1).length >
        0;

      this.hasLeadTypes =
        filterItems.filter((q) => parseInt(q.id) == 2 && q.status == 1).length >
        0;

      if (
        this.hasCategory == false &&
        this.hasKeywords == false &&
        this.hasCountry == false &&
        this.hasLeadTypes == false
      ) {
        this.hasFilterItems = false;
      }

      if (this.hasCategory) {
        this.getMainCategories();
      }

      if (this.hasCountry) {
        this.getCountries();
      }
    }

    helper.SetSelect2();
    // #endregion

    // #region LeadsFilter
    var leadContentX = this.$store.state.domainContentX.LeadContent;
    var keywords = leadContentX.Keywords;

    var selectedCategories = leadContentX.SelectedCategories;
    var selectedLeads = leadContentX.SelectedLeads;
    var selectedCountries = leadContentX.SelectedCountries;
    this.selectedLeadTypes = leadContentX.SelectedLeadTypes;
    if (this.selectedLeadTypes.length > 0) {
      var temp = [];
      this.selectedLeadTypes.forEach((element) => {
        var type = parseInt(element);
        temp.push(type);
      });
      this.selectedLeadTypes = [];
      this.selectedLeadTypes = temp;
    }

    if (keywords.length > 0) {
      this.keywords = [];
      keywords.forEach((element) => {
        var text = element.text;
        this.keywords.push(text);
      });
    }

    if (selectedLeads.length > 0) {
      this.selectedLeads = [];
      selectedLeads.forEach((element) => {
        var leadId = parseInt(element.id);
        this.selectedLeads.push(leadId);
      });
    }

    if (selectedCategories.length > 0) {
      this.selectedCategories = [];
      selectedCategories.forEach((element) => {
        var categoryId = parseInt(element.categoryId);
        var mainCategoryId = parseInt(element.mainCategoryId);

        this.selectedCategories.push(categoryId);
        this.selectedMainAndSubCategories.push({
          mainCategoryId: mainCategoryId,
          categoryId: categoryId,
        });
      });
    }

    if (selectedCountries.length > 0) {
      this.selectedCountries = [];
      selectedCountries.forEach((element) => {
        var countryId = parseInt(element);
        this.selectedCountries.push(countryId);
      });
    }

    // #endregion

    this.getLeadsList(0);
  },
};
</script>



<style></style>
<style lang="postcss">
.btn-check:active + .btn-outline-on-secondary,
.btn-check:checked + .btn-outline-on-secondary,
.btn-outline-on-secondary.active,
.btn-outline-on-secondary.dropdown-toggle.show,
.btn-outline-on-secondary:active {
  background-color: var(--m3--sys--dark--on-secondary-container);
  border-color: var(--m3--sys--dark--on-secondary-container);
}

.btn-outline-on-secondary {
  border-radius: 8px;
  color: var(--m3--sys--dark--on-secondary-container);
  border-color: var(--m3--sys--dark--on-secondary-container);
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  position: static;
  height: 32px;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  letter-spacing: 0.1px;
  font-feature-settings: "liga" off;
  /* M3/sys/light/on-secondary-container */

  color: var(--m3--sys--light--on-secondary-container);
  border-color: var(--m3--sys--light--on-secondary-container);
  padding: 6px 12px;
}

.did-floating-label-content {
  position: relative;
  margin-bottom: 20px;
}
.did-floating-label {
  color: #1e4c82;
  font-size: 13px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 15px;
  top: 20px;
  padding: 0 5px;
  background: var(--m3--sys--light--on-primary);
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}
.did-floating-input,
.did-floating-select {
  font-size: 12px;
  display: block;
  width: 100%;
  height: 56px;
  padding: 0 20px;
  background: var(--m3--sys--light--on-primary);
  border-radius: 4px;
  box-sizing: border-box;

  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.5px;

  /* M3/sys/light/on-surface */
  color: var(--m3--sys--light--on-surface-variant);
}
.did-floating-input:focus,
.did-floating-select:focus {
  outline: none;
  box-shadow: none !important;
}
.did-floating-input:focus ~ .did-floating-label,
.did-floating-select:focus ~ .did-floating-label {
  top: -8px;
  font-size: 13px;
}
select.did-floating-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
select.did-floating-select::-ms-expand {
  display: none;
}
.did-floating-input:not(:placeholder-shown) ~ .did-floating-label {
  top: -8px;
  font-size: 13px;
}
.did-floating-select:not([value=""]):valid ~ .did-floating-label {
  top: -8px;
  font-size: 13px;
}
.did-floating-select[value=""]:focus ~ .did-floating-label {
  top: 20px;
  font-size: 13px;
}
.did-floating-select:not([multiple]):not([size]) {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6'%3E%3Cpath id='Path_1' data-name='Path 1' d='M371,294l4,6,4-6Z' transform='translate(-371 -294)' fill='%23003d71'/%3E%3C/svg%3E%0A");
  background-position: right 15px top 50%;
  background-repeat: no-repeat;
}
/* .did-error-input .did-floating-input, .did-error-input .did-floating-select {
  border: 2px solid #9d3b3b;
  color: #9d3b3b;
}
.did-error-input .did-floating-label {
  font-weight: 600;
  color: #9d3b3b;
}
.did-error-input .did-floating-select:not([multiple]):not([size]) {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6'%3E%3Cpath id='Path_1' data-name='Path 1' d='M371,294l4,6,4-6Z' transform='translate(-371 -294)' fill='%239d3b3b'/%3E%3C/svg%3E%0A");
} */
.input-group {
  display: flex;
}
.input-group .did-floating-input {
  border-radius: 0 4px 4px 0;
  border-left: 0;
  padding-left: 0;
}
.input-group-append {
  display: flex;
  align-items: center;
  /*   margin-left:-1px; */
}
.input-group-text {
  display: flex;
  align-items: center;
  font-weight: 400;
  height: 34px;
  padding: 0 5px 0 20px;
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
  border-radius: 4px 0 0 4px;
  border-right: none;
}
option {
  /* M3/read-only/light/surface2 */
  background: var(--m3--read-only--light--surface2);
  /* M3/Elevation Light/2 */
  border-radius: 4px;
}

option:hover,
select:focus > option:checked {
  background: var(--m3--read-only--light--primary--opacity-012) !important;
  background-color: var(
    --m3--read-only--light--primary--opacity-012
  ) !important;
}

.leads-filter-area .form-check {
  min-width: 48%;
}

.leads-filter-area .form-check label {
  width: 100%;
}

.lead-sell-request {
  border: 1px solid var(--m3--source---seed) !important;
}

.lead-sell-request > span {
  color: var(--m3--source---seed) !important;
}

.lead-free-box {
  border: 1px solid var(--green-500) !important;
}

.lead-free-box > span {
  color: var(--green-500) !important;
}
.lead-free-box > i {
  color: var(--green-500) !important;
}

.more-svg {
  background: transparent !important;
}
.more-svg svg {
  width: 70px !important;
}

.c-loader {
  background: transparent !important;
}

/*------------*/

.lead-page-lead-item {
  padding: 16px;
  background-color: #fff;
  border-radius: 25px;
  margin-bottom: 16px;
}

.lead-item-top {
  min-height: 93px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(116, 119, 127, 0.08);
}

.lead-item-top > a {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  letter-spacing: 0.1px;
  color: #005eb5;
  margin-bottom: 8px;
}

.lead-item-top > a > span {
  margin-right: 10px;
  width: 78%;
}

.lead-item-top > p {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  letter-spacing: 0.5px;
  color: #1b1b1d;
  margin-bottom: 10px;
}
</style>
